import React, { useEffect, useState } from "react"
import { Col, Row, Table, Form, Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import {
  emailPurchaseOrderToSupplier,
  changeStatusPurchaseOrder,
  getPurchaseOrder,
  proxyFile,
} from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import {
  getCurrentDateTimeYYMMDDHHMMSS,
  dateFormat,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import Modal from "antd/es/modal/Modal"
import toast from "react-hot-toast"
import ElmhurstLogo from "../../../../Assets/Images/elmhurst-initial-logo.png"
// import cleanLogo from "../../../../Assets/Images/Login/transparent_bg.png"
// import signature from "../../../../Assets/Images/signature.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import POModal from "./POModal"
import PaymentTable from "../../../Sales/PaymentTable"
import Moment from "moment"
import { emailPurchaseOrder } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

export default function PrintPurchaseOrder() {
  const { id } = useParams()
  const poID = id
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [printPO, setPrintPO] = useState([])
  const [items, setItems] = useState([])
  // const [note, setNote] = useState("")
  const [paymentInfo, setPaymentInfo] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)
  const [prepBySignature, setPrepBySignature] = useState()
  const [apprBySignature, setApprBySignature] = useState()

  async function fetchPO() {
    setPrintPO({})
    setItems([])
    const response = await getPurchaseOrder(poID)

    if (response.error) {
      TokenExpiry(response)
    } else {
      setPrintPO(response.response.data[0])
      setFileList(response.response.data[0].purchase_attachments)
      var itemDeets = response.response.data[0].purchase_items

      itemDeets.map((item) => {
        var info = {}

        info.detail = item.item_name ? item.item_name : ""
        info.description = item.description
        info.discount_amount = item.discount_amount
        info.discount_percentage = item.discount_percentage
        info.id = item.id
        info.ingredient_id = item.ingredient_id
        info.qty = parseInt(item.qty)
        info.unit = item.unit
        info.price = item.price
        info.amount = item.amount
        info.receive_qty =
          item.received_qty === null ? 0 : parseInt(item.received_qty)
        info.current_qty =
          item.inventory_qty === null ? 0 : parseInt(item.inventory_qty)
        info.remarks = item.remarks
        info.item_code = item.item_code
        info.item_size = item.item_size

        setItems((prev) => [...prev, info])
      })

      var payment = response.response.data[0].purchase_payment?.map((data) => {
        var info = data
        info.payment_date = Moment(data.payment_date).format("MMM DD, YYYY")
        // info.payment_mode = data.payment_mode === "cash";
        info.details =
          data.payment_mode === "check"
            ? data.payment_mode + " - " + data.check_no
            : data.payment_mode === "bank"
            ? data.payment_mode + " - " + data.reference_no
            : data.payment_mode === "others"
            ? data.type
              ? data.reference_no
                ? data.type + " - " + data.reference_no
                : data.type
              : data.reference_no
            : data.payment_mode
        info.amount = data.amount ? numberFormat(data.amount) : "0.00"
        info.amount_applied_to_invoice = data.amount_applied_to_invoice
          ? numberFormat(data.amount_applied_to_invoice)
          : "0.00"
        return info
      })
      setPaymentInfo(payment)

      // Convert signatures to base64 after data is loaded
      convertFromHtmlToImage(response.response.data[0])
    }
  }

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  async function handlePrintPO() {
    setIsClicked(true)

    const response = await changeStatusPurchaseOrder(poID, "print")

    if (response.response) {
      const response1 = await changeStatusPurchaseOrder(poID, "sent")
      if (response1.response) {
        toast.loading("Printing Purchase Order", {
          style: toastStyle(),
        })
        handleClosePrintModal()
        setTimeout(() => {
          toast.dismiss()
          Print()
        }, 1000)
      } else {
        TokenExpiry(response1)
      }
    } else {
      TokenExpiry(response)

      toast.error("Error Printing Purchase Order", {
        style: toastStyle(),
      })
    }

    setTimeout(() => {
      toast.dismiss()
      refreshPage()
    }, 1000)
  }

  async function handleSendToSupplier() {
    // setIsClicked(true);
    if (printPO.supplier_email || printPO.vendor_email) {
      const response = await emailPurchaseOrder(id)
      if (response.response) {
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        setTimeout(() => {
          navigate("/purchaseorders", {
            params: {
              state: "sent",
            },
          })
        }, 1000)
      } else {
        toast.error("Email not sent", {
          style: toastStyle(),
        })
        setTimeout(() => {
          setIsClicked(false)
          handleCloseSendModal()
        }, 1000)
      }
    } else {
      toast.error("Error sending email. Supplier has no email!", {
        style: toastStyle(),
      })
      setTimeout(() => {
        setIsClicked(false)
        handleCloseSendModal()
      }, 1000)
    }
  }

  const handleSendEmail = async (ref) => {
    if (ref) {
      const element = document.getElementById(ref)
      setIsClicked(true)

      html2canvas(element).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7) // Adjust the quality here (0.7 is just an example)
        const pdf = new jsPDF()
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 5
        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        )

        // Convert the pdf file from Blob to File obj (needed for upload API)
        var blobPdf = pdf.output("blob")

        const dateToday = getCurrentDateTimeYYMMDDHHMMSS()
        const formPdf = new File([blobPdf], `Puchase_Order_${dateToday}.pdf`, {
          type: blobPdf.type,
        })

        // if (printPO.supplier_email || printPO.vendor_email) {
        const response = await emailPurchaseOrderToSupplier(id, formPdf)

        if (response.response) {
          toast.success(response.response.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/purchaseorders", {
              params: {
                state: "sent",
              },
            })
          }, 1000)
        } else {
          setIsClicked(false)
          toast.error("Email not sent", {
            style: toastStyle(),
          })
          setTimeout(() => {
            setIsClicked(false)
            handleCloseSendModal()
          }, 1000)
        }
        // }
      })
    }
  }

  async function convertFromHtmlToImage(data) {
    const preparedBySignatureLink = data.added_by_name_signature
    const approvedBySignatureLink = data.approved_by_name_signature
    try {
      if (preparedBySignatureLink) {
        const prepByBase64Data = await imageUrlToBase64(preparedBySignatureLink)
        setPrepBySignature(prepByBase64Data)
      }

      if (approvedBySignatureLink) {
        const apprByBase64Data = await imageUrlToBase64(approvedBySignatureLink)
        setApprBySignature(apprByBase64Data)
      }
    } catch (error) {
      console.error("Error converting signatures:", error)
    }
  }

  async function imageUrlToBase64(url) {
    try {
      const res = await proxyFile(url)
      if (!res || res.error) return null
      if (!res.blob) return null

      return await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(res.blob)
      })
    } catch (error) {
      console.error("Error converting image URL to base64:", error)
      return null
    }
  }

  function renderTable() {
    return (
      <Table className="align-middle req-table-elm">
        <thead>
          <tr>
            <th></th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>U o M</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Discount</th>
            <th>Price/Unit</th>
            <th>Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index} className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{index + 1}</td>
                <td className="req-table-w-border-sides">{item.item_code}</td>
                <td className="req-table-w-border-sides">
                  {item.description
                    ? item.detail
                      ? item.description + " - " + item.detail
                      : item.description
                    : item.detail}
                </td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                <td className="req-table-w-border-sides">{item.item_size}</td>
                <td className="req-table-w-border-sides">{item.qty}</td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.discount_amount)} (
                  {parseFloat(item.discount_percentage).toFixed(0)}%)
                </td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.amount)}
                </td>
                <td className="req-table-w-border-sides">{item.remarks}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    // setTimeout(() => {
    //   navigate("/purchaseorders");
    //   // refreshPage();
    // }, 1000);
  }

  useEffect(() => {
    fetchPO()
  }, [])

  return (
    <div className="page">
      <div className="print-page page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <br />
        <br />
        <div className="print-container px-3 py-2" id="printablediv">
          {/* <div className="text-end print-header">
            <span>
              PURCHASE ORDER NO. {printPO.id}
            </span>
          </div> */}

          <div className="print-header-elm">
            <div className="w-full">
              <div className="print-top d-flex py-1">
                <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
              </div>
              <div className="print-top">
                {/* <h1 className="print-shop-header d-flex justify-content-start">ELMHURST ENTERPRISES</h1> */}
                <h5 className="print-shop-header-elm d-flex">
                  497 D Molave Extension, Lahug, Cebu City
                </h5>
                {/* <h5 className="print-shop-header-elm d-flex justify-content-start">San Roque, Cebu City</h5> */}
              </div>
            </div>
            <div className="purchase-order-number-print-container w-full">
              <h1 className="purchase-order-title-print-elm">
                PURCHASE ORDER{" "}
              </h1>
              <div className="po-date-elm">
                <div className="po-date-and-number">
                  <h5 className="print-shop-header-elm text-end print-label fw-bold">
                    PO Date: {dateFormat(printPO.purchase_date)}
                  </h5>
                  <h5 className="print-shop-header-elm text-end print-label fw-bold">
                    {" "}
                    P.O No.: {printPO.id}
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="supplier-address-container">
            {/* <h2 className="supplier-title-elm">Supplier</h2> */}
            <h4 className="print-shop-header-elm print-data supplier-name-elm ">
              Supplier:{" "}
              {printPO.supplier_trade_name
                ? printPO.supplier_trade_name
                : printPO.vendor_trade_name}
            </h4>
            <h5 className="print-shop-header-elm print-data">
              Delivery Address: {printPO.delivery_address}
            </h5>
          </div>

          {/* content */}
          <div className="mt-5">
            <Row className="">
              <Col className="split-columns">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} sm={7} className="print-data">
                    {printPO.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} sm={7} className="print-data">
                    {printPO.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={5} sm={7} className="print-data">
                    {printPO.contact_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Contact Number:
                  </Col>
                  <Col xs={5} sm={7} className="print-data">
                    {printPO.contact_no}
                  </Col>
                </div>
              </Col>

              <Col lg={5} md={6} className="split-columns">
                {/* <div className="d-flex my-2 align-items-center">
                  <Col md={5} className="print-label">
                    Purchase Date:
                  </Col>
                  <Col md={8} className="print-data">
                    {dateFormat(printPO.purchase_date)}
                  </Col>
                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Delivery Date:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {dateFormat(printPO.delivery_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} sm={5} className="print-label">
                    Requisitioner:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {printPO.requisitioner_name}
                  </Col>
                </div>
              </Col>
            </Row>

            {/* Render the columns as separate rows for smaller screens */}
            <Row className="single-column">
              <Col xs={12} md={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPO.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPO.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPO.contact_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} className="print-label">
                    Contact Number:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPO.contact_no}
                  </Col>
                </div>
              </Col>

              <Col xs={12} md={6}>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={5} md={3} className="print-label">
                    Purchase Date:
                  </Col>
                  <Col xs={7} md={5} className="print-data">
                    {dateFormat(printPO.purchase_date)}
                  </Col>
                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} md={3} className="print-label">
                    Delivery Date:
                  </Col>
                  <Col xs={7} md={5} className="print-data">
                    {dateFormat(printPO.delivery_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={5} md={3} className="print-label">
                    Requisitioner:
                  </Col>
                  <Col xs={7} md={5} className="print-data">
                    {printPO.requisitioner_name}
                  </Col>
                </div>
              </Col>
            </Row>
            <div className="d-flex mt-1 mb-2">
              {/* table */}
              <div className="print-table mt-3">{renderTable()}</div>
            </div>
            <Row className="mt-2">
              <span className="print-footer">{printPO.remarks}</span>
            </Row>
            <div className="px-3">
              <Row>
                <Col
                  xs={8}
                  md={11}
                  className="text-right print-data review-label grand-label-review"
                >
                  Subtotal
                </Col>
                <Col className="text-right print-data review-label grand-label-review ">
                  {printPO.subtotal ? numberFormat(printPO.subtotal) : "0.00"}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={8}
                  md={11}
                  className="text-right print-data review-label grand-label-review "
                >
                  Delivery/Service Fee
                </Col>
                <Col className="text-right print-data review-label grand-label-review ">
                  {printPO.service_fee
                    ? numberFormat(printPO.service_fee)
                    : "0.00"}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={8}
                  md={11}
                  className="text-right print-data review-label grand-label-review "
                >
                  Discount
                </Col>
                <Col className="text-right print-data review-label grand-label-review ">
                  {printPO.discount ? numberFormat(printPO.discount) : "0.00"}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={8}
                  md={11}
                  className="text-right bolder print-data review-label grand-label-review "
                >
                  TOTAL:
                </Col>
                <Col className="text-right bolder print-data review-label grand-label-review ">
                  {printPO.grand_total
                    ? numberFormat(printPO.grand_total)
                    : "0.00"}
                </Col>
              </Row>
            </div>
            {/* <Row className="mt-4">
              <span className="print-footer">{printPO.remarks}</span>
            </Row> */}

            {/* <Row className="mt-4 additional-note-input">
              <Col xs={8}>
                <div className="d-flex my-2 align-items-center">
                  <Col
                    xs={4} lg={2}
                    className="print-label"
                    style={{
                      color: "var(--primary-color)",
                      fontFamily: "Gotham-Rounded-Medium",
                    }}
                  >
                    Additional Note:{" "}
                  </Col>
                  <Col xs={8} lg={5} className="print-data">
                    <Form.Control
                      size="sm"
                      type="text"
                      name="additional note"
                      className="nc-modal-custom-input"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      required
                    />
                  </Col>
                </div>
              </Col>
            </Row> */}

            <Row className="my-5 d-flex flex-column flex-sm-row gap-5 gap-sm-0 signature-cont">
              <Col className="d-flex flex-column justify-content-center align-items-center">
                <img src={prepBySignature} className="print-logo" alt="" />
                <p className="print-data underline-border">
                  {printPO.added_by_name}
                </p>
                <p className="print-data">Prepared by</p>
              </Col>
              <Col className="d-flex flex-column justify-content-center align-items-center">
                <img src={apprBySignature} className="print-logo" alt="" />
                <p className="print-data underline-border">
                  {printPO.approved_by_name}
                </p>
                <p className="print-data">Approved by</p>
              </Col>
            </Row>
            {/* <Row className="mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className=" justify-content-center gotham align-items-center d-flex">
                  <p className="print-data"> {printPO.added_by_name}</p>
                  <div className="margin-underline"></div>
                  <p className="print-data">Prepared by</p>
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  <p className="print-data">{printPO.approved_by_name}</p>
                  <div className="margin-underline"></div>
                  <p className="print-data">Approved by</p>
                </Row>
              </Col>
            </Row> */}
            {/* <Col xs={4} className="mt-5 print-sig justify-content-center d-flex">
              <img src={printPO.added_by_name_signature} className="print-logo" />
            </Col>
            <Col xs={4} className="mt-2 mb-5 print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                {printPO.added_by_name}
                <div className="margin-underline"></div>
                Prepared by
              </Row>
            </Col>
            
            <Col xs={4} className="mt-5 print-sig justify-content-center d-flex">
              <img src={printPO.approved_by_name_signature} className="print-logo" alt=""/>
            </Col>
            <Col xs={4} className="mt-2 mb-5 print-sig justify-content-center d-flex">
              <Row className="print-sig justify-content-center gotham">
                {printPO.approved_by_name}
                <div className="margin-underline"></div>
                Approved by
              </Row>
            </Col> */}
            {/* <div className="print-signatures mt-5">
              <div className="d-flex align-items-center justify-content-end flex-column">
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {printPO.added_by_name}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {printPO.approved_by_name}
                </span>
              </div>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Prepared by</span>
              <span>Approved by</span>
            </div> */}
          </div>
        </div>

        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          <Row className="">
            {fileList &&
              fileList.map((attachment) => (
                <Col
                  xs={1}
                  onClick={() => {
                    setPreviewFile(attachment.file_url)
                    setPreview(true)
                  }}
                  className="cursor-pointer preview-container"
                >
                  <img src={attachment.file_url} className="img-preview" />
                </Col>
              ))}
            {!fileList ||
              (fileList.length === 0 && (
                <Col xs={1}>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                    <img
                      src={noDataImg}
                      alt="no data found"
                      className="img-preview"
                    />
                  </div>
                </Col>
              ))}
          </Row>
        </div>
        {printPO.status === "sent" && (
          <>
            <div className=" mt-3">
              <div className="tab-content">
                <h5 className="PI-payment-info mt-3 ms-3">PAYMENT HISTORY</h5>
                <PaymentTable
                  tableHeaders={[
                    "PAYMENT DATE",
                    "TYPE",
                    "DETAILS",
                    "PAYMENT AMOUNT",
                    "AMOUNT APPLIED TO INV",
                  ]}
                  headerSelector={[
                    "payment_date",
                    "payment_mode",
                    "details",
                    "amount",
                    "amount_applied_to_invoice",
                  ]}
                  tableData={paymentInfo}
                />
              </div>
            </div>
            {/* <Container
              fluid
              className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
            >
              <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
              <div className="justify-content-center">
                <PaymentTable
                  tableHeaders={[
                    "PAYMENT DATE",
                    "TYPE",
                    "DETAILS",
                    "PAYMENT AMOUNT",
                    "AMOUNT APPLIED TO INV",
                  ]}
                  headerSelector={[
                    "payment_date",
                    "type",
                    "details",
                    "amount",
                    "amount_applied_to_invoice",
                  ]}
                  tableData={paymentInfo}
                />
              </div>
            </Container> */}
          </>
        )}

        {/* footer */}
        <div className="d-flex justify-content-end my-3">
          <button
            className="button-secondary me-1"
            // style={{ width: "100%" }}
            onClick={() => navigate("/purchaseorders")}
          >
            Close
          </button>
          <button
            className="button-tertiary me-1"
            // style={{ width: "100%" }}
            onClick={handleShowSendModal}
          >
            Send to Supplier
          </button>
          <button
            className="button-primary"
            // style={{ width: "100%" }}
            onClick={handleShowPrintModal}
          >
            Print
          </button>
        </div>
        <br />
      </div>
      {/* modals */}
      <POModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={handlePrintPO}
        isClicked={isClicked}
      />

      <POModal
        show={showSendModal}
        hide={handleCloseSendModal}
        type="send"
        handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="attachment"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <Footer />
    </div>
  )
}
